module.exports = __webpack_public_path__ + "media/images/home/flow_p_index_3-803e066dc7853c2ca28d880c0ee227f0.svg";